import { render, staticRenderFns } from "./TicketsCart.vue?vue&type=template&id=a6450c28&scoped=true&"
import script from "./TicketsCart.vue?vue&type=script&lang=js&"
export * from "./TicketsCart.vue?vue&type=script&lang=js&"
import style0 from "./TicketsCart.vue?vue&type=style&index=0&id=a6450c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6450c28",
  null
  
)

export default component.exports